import * as React from 'react';
import { Box, Button, Divider, Grid, Paper, Tooltip, Typography } from '@mui/material';
import { withStyles } from '../../settings/styles';
import { connect } from 'react-redux';
import { AppState } from '../../model/reducers';
import { ThunkDispatch } from 'redux-thunk';
import { loadingOverlay, broadcastMessage } from '../../model/overlay/actions';
import { BroadcastType } from '../../model/overlay/types';
import { AddIcCall, Check, Description, HelpOutline, PictureAsPdf } from '@mui/icons-material';
import { NavigationTabProps } from '../../model/navigation/types';
import { withTranslation } from 'react-i18next';



// ----------------- State & Props -----------------  //

interface State 
{

};

interface StateProps
{

};

interface DispatchProps
{
    loading: ()=>void;
    doneLoading: ()=>void;
    broadcast: (msg: string, type?: BroadcastType) => void;
};

type Props = NavigationTabProps & StateProps & DispatchProps;

// -------------------- Class --------------------  //

class AvailableServices extends React.Component<Props, State> 
{
    // ============================================ //
    //               Member Variables               //
    // ============================================ //

    translation: any;

    // ============================================ //
    //               Routine Functions              //
    // ============================================ //

    constructor(props: any)
    {
        super(props);

        // Init State
        this.state = {

        };

        // Setup Member Functions
    }

    render()
    {
        const { t } = this.props;
        return (<>
            <Box sx={{ maxWidth: 936, margin: 'auto', overflow: 'hidden' }}>
                <Typography sx={{mb: "30px", ml: 1, fontSize: 18, fontWeight: 5}}>
                    {t('services.availableServices')}
                </Typography>
            </Box>
            <Paper sx={{ maxWidth: 936, margin: 'auto', height: 'auto', overflow: 'hidden' }}>
                <Grid container columns={10} sx={{padding: 0}}>
                    <Grid item xs={7}>
                        <Typography sx={{margin: 2}}>
                            <PictureAsPdf sx={{verticalAlign: 'middle', mr: 1, pb: "3px"}} />
                            Fortnox PDF Invoices
                            <Tooltip title={<>
                                {t('services.fortnoxPdfInvoiceHelp')}:
                                <li style={{marginLeft: 8}}>Invoice PDF Viewer</li>
                            </>}>
                                <HelpOutline sx={{p: "2px", pt: "1px", ml: "8px", verticalAlign: 'middle'}}/>
                            </Tooltip>
                        </Typography>
                    </Grid>
                    <Grid item xs={3} sx={{textAlign: "end"}}>
                        <Button sx={{margin: 1}} color="secondary" disabled><Check sx={{verticalAlign: "middle", marginRight: "5px"}} />{t('general.access')}</Button>
                    </Grid>
                    <Grid item xs={10}>
                        <Divider></Divider>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography sx={{margin: 2}}>
                            <PictureAsPdf sx={{verticalAlign: 'middle', mr: 1, pb: "3px"}} />
                            Hogia PDF Invoices
                            <Tooltip title={<>
                                {t('services.hogiaPdfInvoiceHelp')}:
                                <li style={{marginLeft: 8}}>Invoice PDF Viewer</li>
                            </>}>
                                <HelpOutline sx={{p: "2px", pt: "1px", ml: "8px", verticalAlign: 'middle'}}/>
                            </Tooltip>
                        </Typography>
                    </Grid>
                    <Grid item xs={3} sx={{textAlign: "end"}}>
                        <Button sx={{margin: 1}} color="secondary" disabled><Check sx={{verticalAlign: "middle", marginRight: "5px"}} />{t('general.access')}</Button>
                    </Grid>
                    <Grid item xs={10}>
                        <Divider></Divider>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography sx={{margin: 2}}>
                            <PictureAsPdf sx={{verticalAlign: 'middle', mr: 1, pb: "3px"}} />
                            Business Central PDF Invoices
                            <Tooltip title={<>
                                {t('services.businessCentralPdfInvoiceHelp')}:
                                <li style={{marginLeft: 8}}>Invoice PDF Viewer</li>
                            </>}>
                                <HelpOutline sx={{p: "2px", pt: "1px", ml: "8px", verticalAlign: 'middle'}}/>
                            </Tooltip>
                        </Typography>
                    </Grid>
                    <Grid item xs={3} sx={{textAlign: "end"}}>
                        <Button sx={{margin: 1}} color="secondary" disabled><Check sx={{verticalAlign: "middle", marginRight: "5px"}} />{t('general.access')}</Button>
                    </Grid>
                    <Grid item xs={10}>
                        <Divider></Divider>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography sx={{margin: 2}}>
                            <Description sx={{verticalAlign: 'middle', mr: 1, pb: "3px"}} />
                            Sheet PDF Generator
                            <Tooltip title={<>
                                {t('services.sheetPdfGeneratorHelp')}:
                                <li style={{marginLeft: 8}}>Document Generator</li>
                            </>}>
                                <HelpOutline sx={{p: "2px", pt: "1px", ml: "8px", verticalAlign: 'middle'}}/>
                            </Tooltip>
                        </Typography>
                    </Grid>
                    <Grid item xs={3} sx={{textAlign: "end"}}>
                        <a href="https://viewbase.se/kontakt/">
                            <Button sx={{margin: 1}} color="secondary"><AddIcCall sx={{marginRight: "10px"}}/>{t('general.contactSales')}</Button>
                        </a>
                    </Grid>
                </Grid>
            </Paper>
        </>);
    }

    // ============================================ //
}

// ----------------- Export -----------------  //

const mapStateToProps = (state: AppState, props: NavigationTabProps): StateProps => ({

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{},{},any>, props: NavigationTabProps): DispatchProps => ({
    loading: ()=>dispatch(loadingOverlay(true)),
    doneLoading: ()=>dispatch(loadingOverlay(false)),
    broadcast: (msg, type?)=>dispatch(broadcastMessage(msg, type))
});

export default withStyles(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AvailableServices)));

// ------------------------------------------  //